<template>
  <a-layout-sider theme="dark" v-model="collapsed" collapsible>
    <!-- <a-layout-sider theme="dark" > -->

    <a-menu
      style="width: 100%"
      :default-open-keys="[sub]"
      :open-keys="[sub]"
      :default-selected-keys="['index']"
      :selected-keys="[current]"
      theme="dark"
      mode="inline"
      @click="handleClick"
      @openChange="subClick"
    >
      <template v-for="item in siders">
        <a-menu-item
          :key="item.key"
          v-if="!item.list && item.rule != 0"
          style="font-size: 16px"
        >
          <a-icon v-if="item.icon != ''" :type="item.icon" />

          <!-- <i v-if="item.component == 'map' || item.component == 'map2'" data-v-fcd3770a="" aria-label="图标: home" class="anticon anticon-home" style="transform:scale(1.3)">
            <svg
              t="1659607092421"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2944"
              style="display: inline-block;"
            >
              <path
                d="M786.432 542.421333a25.685333 25.685333 0 0 1 5.973333-20.650666 29.653333 29.653333 0 0 1 22.229334-9.642667c14.506667 0 26.069333 9.472 27.904 23.168l51.925333 324.437333v0.213334c1.706667 12.416-2.133333 24.618667-10.538667 34.261333-10.410667 11.904-26.581333 18.858667-44.672 18.773333l-3.029333-0.512-177.621333-51.541333-140.117334 48h-5.546666l-138.453334-48L190.976 913.066667c-16.853333 0-33.066667-6.997333-43.477333-18.858667a42.837333 42.837333 0 0 1-10.581334-34.304l51.925334-324.394667c1.621333-13.482667 13.781333-23.552 27.904-23.552a29.141333 29.141333 0 0 1 22.144 9.856c4.992 5.674667 7.253333 13.226667 6.058666 20.736l-50.474666 315.392 178.304-51.2 5.12 0.128 137.813333 47.786667 139.52-47.786667 5.162667-0.128 176.725333 51.797334-50.688-316.16z m-270.72-266.069333A128.768 128.768 0 0 1 644.266667 404.821333a128.725333 128.725333 0 0 1-128.512 128.512 128.725333 128.725333 0 0 1-128.469334-128.512 128.725333 128.725333 0 0 1 128.469334-128.469333z m0 209.92a81.237333 81.237333 0 0 0 81.493333-81.450667c0-45.141333-36.309333-81.408-81.493333-81.408-45.141333 0-81.450667 36.266667-81.450667 81.450667a81.194667 81.194667 0 0 0 81.450667 81.408z m-258.56-8.704l-0.256-0.768A270.72 270.72 0 0 1 515.712 128a270.72 270.72 0 0 1 258.901333 348.458667l-0.682666 2.346666a185.728 185.728 0 0 1-8.832 24.064 267.562667 267.562667 0 0 1-54.613334 82.858667c-30.976 36.778667-70.357333 74.069333-114.048 110.08-26.794667 22.101333-50.176 39.68-64.426666 49.621333l-16.298667 11.392-4.906667-3.413333-11.349333-7.978667a1080.917333 1080.917333 0 0 1-64.597333-49.749333c-43.818667-36.181333-83.456-73.770667-114.432-110.592a265.813333 265.813333 0 0 1-54.186667-82.474667 180.48 180.48 0 0 1-8.746667-23.850666L257.28 477.866667l-0.128-0.298667z m411.178667 70.101333c19.584-20.309333 34.304-42.538667 44.672-67.328 2.688-6.016 4.778667-11.776 6.4-17.322666l0.512-1.92a213.888 213.888 0 0 0-204.202667-276.352 213.888 213.888 0 0 0-204.074667 276.736l0.426667 1.578666v0.085334c1.578667 5.461333 3.669333 11.093333 6.272 16.981333 10.282667 24.746667 25.173333 47.274667 44.245333 66.986667 41.898667 49.749333 98.218667 98.816 153.173334 139.861333 54.826667-41.002667 110.848-89.770667 152.576-139.306667z"
                p-id="2945"
                fill="currentColor"
              ></path>
            </svg>
          </i> -->

          <i
            v-if="item.component == 'index'"
            data-v-fcd3770a=""
            aria-label="图标: index"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/category.png"
            /> -->
          </i>

          <i
            v-if="item.component == 'zglist'"
            data-v-fcd3770a=""
            aria-label="图标: index"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/zg.png"
            /> -->
          </i>

          <i
            v-if="item.component == 'dmlist'"
            data-v-fcd3770a=""
            aria-label="图标: index"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/dm.png"
            /> -->
          </i>

          <i
            v-if="item.component == 'map' || item.component == 'map2'"
            data-v-fcd3770a=""
            aria-label="图标: map"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/Map.png"
            /> -->
          </i>

          <i
            v-if="item.component == 'markerlist'"
            data-v-fcd3770a=""
            aria-label="图标: markerlist"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/cysy.png"
            /> -->
          </i>


          <i
            v-if="item.component == 'hllist'"
            data-v-fcd3770a=""
            aria-label="图标: dmlist"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/structure-manage.png"
            /> -->
            <a-icon type="align-center" style="display: inline-block; margin-right:-10px;margin-left:-10px; font-size:18px; margin-top:-5px;" />
          </i>

          <i
            v-if="item.component == 'teammag'"
            data-v-fcd3770a=""
            aria-label="图标: teammag"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/staff-manage.png"
            /> -->
          </i>

          <i
            v-if="item.component == 'samplinglist'"
            data-v-fcd3770a=""
            aria-label="图标: samplinglist"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/structure-manage.png"
            /> -->
          </i>

          <span>{{ item.title }}</span>
        </a-menu-item>
        <a-sub-menu :key="item.key" v-if="item.list && item.rule != 0">
          <span slot="title" style="font-size: 16px">
            <!-- <a-icon :type="item.icon" /> -->

          <i
            v-if="item.component == 'map' || item.component == 'map2'"
            data-v-fcd3770a=""
            aria-label="图标: map"
            class="anticon anticon-home"
            style="transform:scale(1)"
          >
            <!-- <img
              style="width:16px;display: inline-block; margin-top:-10px;"
              src="../assets/icon/Map.png"
            /> -->
          </i>
            <i
              v-if="item.component == 'teammag'"
              data-v-fcd3770a=""
              aria-label="图标: teammag"
              class="anticon anticon-home"
              style="transform:scale(1)"
            >
              <!-- <img
                style="width:16px;display: inline-block; margin-top:-10px;"
                src="../assets/icon/staff-manage.png"
              /> -->
            </i>

            <i
              v-if="item.component == 'datalist'"
              data-v-fcd3770a=""
              aria-label="图标: datalist"
              class="anticon anticon-home"
              style="transform:scale(1)"
            >
              <!-- <img
                style="width:16px;display: inline-block; margin-top:-10px;"
                src="../assets/icon/data-check.png"
              /> -->
            </i>

            <span>{{ item.title }}</span>
          </span>

          <template v-for="itemf in item.list">
            <a-menu-item
              :key="itemf.key"
              v-if="itemf.rule != 0"
              style="font-size: 16px"
            >
              {{ itemf.title }}
            </a-menu-item>
          </template>
        </a-sub-menu>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import global from "../common";
export default {
  name: "TopBar",
  components: {},
  props: {
    msg: String,
    showback: String,
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Map,
      logininfo: {},
      current: "index",
      sub: "",
      siders: []
    };
  },
  mounted() {},
  created() {
    let key = this.GetPageKey();
    this.current = key;
    let keyary = key.split("/");
    if (keyary.length > 1) {
      this.sub = keyary[0];
    }

    this.siders = global.getSider();
    // console.log("global-siders", this.siders);
  },
  methods: {
    subClick(e) {
      if (e.length > 1) {
        this.sub = e[1];
      } else {
        this.sub = "";
      }
    },
    handleClick(e) {
      // console.log(e);
      let key = e.key;
      this.current = key;
      let keyary = key.split("/");

      if (keyary.length > 1) {
        this.sub = keyary[0];
      }

      if (this.GetPageKey() != key) {
        global.setPageKey(key);
        this.$router.push("/" + key);
      }
    },
    GetPageKey() {
      var str = this.$route.path;
      var num = str.indexOf("/");
      str = str.substr(num + 1);
      return str;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.showbackdiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}
.showback {
  background-color: #fd711c;
  border-color: #fd711c;
  font-size: 14px;
}
</style>
